export const getBounds = (centre, radius) => {
  const points = [];

  const EARTH_RADIUS = 6378100.0;
  // Convert to radians.

  const lat = centre.lat * Math.PI / 180.0;
  const lng = centre.lng * Math.PI / 180.0;

  for (let t = 0; t <= Math.PI * 2; t += 0.3) {
    // y
    const latPoint = lat + (radius / EARTH_RADIUS) * Math.sin(t) / Math.cos(lat);
    // x
    const lngPoint = lng + (radius / EARTH_RADIUS) * Math.cos(t) / Math.cos(lat);

    // saving the location on circle as a LatLng point
    const point = {
      lat: latPoint * 180.0 / Math.PI,
      lng: lngPoint * 180.0 / Math.PI
    };

    points.push(point);
  }

  const lats = points.map(p => p.lat);
  const lngs = points.map(p => p.lng);

  return {
    lat_min: Math.min(...lats),
    lat_max: Math.max(...lats),
    lng_min: Math.min(...lngs),
    lng_max: Math.max(...lngs)
  };
}
;

export const isInViewport = (location, viewport) => {
  if ((viewport.sw?.lng || viewport.lng_min) <= location.lng && (viewport.ne?.lng || viewport.lng_max) >= location.lng) {
    // is in width
    if ((viewport.sw?.lat || viewport.lat_min) <= location.lat && (viewport.ne?.lat || viewport.lat_max) >= location.lat) {
      return true;
    }
  }
  return false;
}
;

export const viewPortToMinMax = (viewport) => {
  return {
    lng_min: viewport.sw.lng,
    lng_max: viewport.ne.lng,
    lat_min: viewport.sw.lat,
    lat_max: viewport.ne.lat
  };
}
;
